import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const ContactsPage = lazy(() => import("@/pages/contacts/ContactsPage"));
const ContactCreatePage = lazy(() => import("@/pages/contacts/ContactCreatePage"));
const ContactEditPage = lazy(() => import("@/pages/contacts/ContactEditPage"));

export function ContactRoutes() {
  return (
    <>
      <Route path="/contacts" element={<ProtectedRoute><ContactsPage /></ProtectedRoute>} />
      <Route path="/contacts/new" element={<ProtectedRoute><ContactCreatePage /></ProtectedRoute>} />
      <Route path="/contacts/:id" element={<ProtectedRoute><ContactEditPage /></ProtectedRoute>} />
    </>
  );
}
